import axios from 'axios';

const instance = axios.create({
  baseURL: '/', // 设置基础 URL
  // timeout: 5000, // 设置请求超时时间
});

// 请求拦截器
instance.interceptors.request.use(
  (config) => {
    if (!config.headers['Authorization']) {
      config.headers['Authorization'] = 'Basic YmlnZGF0YV92OjJBNzM2MUEzLTZCQTMtNDNENi05NjkzLTE4RERFMjc5MjdGRA==';
    }
    return config;
  },
  (error) => {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export function get(url, params) {
  return instance.get(url, { params });
}

export function post(url, data) {
  return instance.post(url, data);
}

export { instance }


export default axios